module.exports = __webpack_public_path__ + "img/08_Flaechenbuendig-Slido Flat@2x.b473568b.jpg";